import {
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";

function ComicImportForm({ handleSubmit, source, isLoading }) {
  const [importUrl, setImportUrl] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(source.sourceKey, importUrl);
  };

  return (
    <form onSubmit={onSubmit}>
      <VStack spacing={4} pt="3">
        <FormControl id="importUrl" isRequired>
          <FormLabel>Import URL</FormLabel>
          <Input
            name="importUrl"
            type="text"
            value={importUrl}
            onChange={(e) => setImportUrl(e.target.value)}
            required
            placeholder={source.urlFormat}
            tabIndex={1}
          />
        </FormControl>

        <Button
          type="submit"
          colorScheme="blue"
          tabIndex={7}
          disabled={isLoading}
        >
          Import{isLoading && "ing"} comic from {source.sourceLabel}
          {isLoading && "..."}
        </Button>
      </VStack>
    </form>
  );
}

export default ComicImportForm;
